import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { alpha } from '@mui/material/styles'
import { Box, Divider, Typography, Stack, MenuItem } from '@mui/material'
import { useAuthContext } from '../../../contexts/AuthContext'
import { CustomAvatar } from '../../../components/custom-avatar'
import MenuPopover from '../../../components/menu-popover'
import { IconButtonAnimate } from '../../../components/animate'
import { constants } from '../../../utils/constants'

const OPTIONS = [
  { label: 'Tablero', linkTo: '/app/tablero' },
  { label: 'Mi Perfil',linkTo: '/app/mi_perfil' },
  { label: 'Tutoriales',linkTo: '/app/video_tutoriales' },
]

export default function AccountPopover() {

  const navigate = useNavigate()

  const { user, logoutCtx } = useAuthContext()

  const [openPopover, setOpenPopover] = useState(null)

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget)
  }

  const handleClosePopover = () => {
    setOpenPopover(null)
  }

  const handleLogout = async () => {
    navigate('/')
    logoutCtx()
  }

  const handleClickItem = (path) => {
    handleClosePopover()
    navigate(path)
  }

  const pathImg = user?.path_img ? `${constants.api.base}/${user.path_img}` : null

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <CustomAvatar src={pathImg} alt={user?.name} name={user?.name} />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.name}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Cerrar sesión
        </MenuItem>
      </MenuPopover>
    </>
  );
}
